import React, { useContext } from 'react';

import style from './blockquote.style';

import Context from '../../context';

const Blockquote = ({ children, ...props }) => {
  const { istInterview, getInterviewColor } = useContext(Context);

  return (
    <blockquote
      css={style(istInterview ? getInterviewColor() : undefined)}
      {...props}
    >
      {children}
    </blockquote>
  );
};

export default Blockquote;
